import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-footer',
  imports: [MatIconModule, CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit, OnDestroy {
  currentYear = new Date().getFullYear();
  appVersion = environment.appVersion;
  showLogoutLink = false;
  isHomePage = true;

  private sub!: Subscription;

  constructor(private router: Router) {}

  ngOnInit() {    
    this.checkLogoutVisibility(this.router.url);
    this.checkRoute();
    this.sub = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.checkLogoutVisibility(event.urlAfterRedirects);
        this.checkRoute();
      }
    });   
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  private checkLogoutVisibility(url: string) {
    const token = localStorage.getItem('accessToken');
    this.showLogoutLink = !!token && !url.includes('/login');
  }

  private checkRoute() {
    const url = this.router.url;
    this.isHomePage = url === '/' || url === '/nuevacontrasena' || url === '/codigocontrasena';
  }



  logout() {
    const account = localStorage.getItem('account');
    localStorage.clear();
    
    if (account && ['2228', '2665', '2559', '2907', '2988'].includes(account)) {
      this.router.navigate(['/'], { queryParams: { uuidc: account } });
    } else {
      this.router.navigate(['/']);
    }
  }

  private getBanamexUuid(): string | null {
    const uuidMatch = this.router.url.match(/uuidc=(\d+)/);
    const uuidc = uuidMatch ? uuidMatch[1] : null;
    return uuidc && ['2228', '2665', '2559', '2907', '2988'].includes(uuidc) ? uuidc : null;
  }

  getPrivacyUrl(): string {
    const uuidc = this.getBanamexUuid();
    return uuidc ? `/privacy?uuidc=${uuidc}` : '/privacy';
  }

  getFaqUrl(): string {
    const account = localStorage.getItem('account');
    const banamexAccounts = ['2228', '2665', '2559', '2907', '2988', '2997', '2998', '2999'];
    
    if (account && banamexAccounts.includes(account)) {
      return `/faq?uuidc=${account}`;
    }
    
    return '/faq?uuidc=2228';
  }

  navigateToFaq(): void {
    const account = localStorage.getItem('account');
    const banamexAccounts = ['2228', '2665', '2559', '2907', '2988', '2997', '2998', '2999'];
    
    if (account && banamexAccounts.includes(account)) {
      this.router.navigate(['/faq'], { queryParams: { uuidc: account } });
    } else {
      this.router.navigate(['/faq'], { queryParams: { uuidc: '2228' } });
    }
  }

  getContactUrl(): string {
    const uuidc = this.getBanamexUuid();
    return uuidc ? `/contact?uuidc=${uuidc}` : '/contact';
  }

  // shouldShowSpotify(): boolean {
  //   const uuidc = this.getBanamexUuid();
  //   const account = localStorage.getItem('account');
  //   const uuidClient = localStorage.getItem('uuidClient');
  //   
  //   // Ocultar en login (cuando hay uuidc en URL)
  //   if (uuidc) return false;
  //   
  //   // Ocultar para cuentas específicas
  //   if (account && ['2228', '2665', '2559', '2907', '2988'].includes(account)) return false;
  //   if (uuidClient && ['2228', '2665', '2559', '2907', '2988'].includes(uuidClient)) return false;
  //   
  //   return true;
  // }

}
